import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function MaskedPhoneInput({ value, onChange, name }: MaskedPhoneInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    { mask: '(00) 00000-0000' },
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value, setValue]);

  return (
    <Input
      ref={ref}
      id={name}
      type="tel"
      placeholder="(00) 00000-0000"
    />
  );
}
